var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequstQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_486_22939",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 53
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 53,
    height: 53,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_486_22939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1088 46.375C14.0924 46.375 13.2438 46.0345 12.5629 45.3536C11.882 44.6727 11.5415 43.8241 11.5415 42.8077V10.1923C11.5415 9.1759 11.882 8.32726 12.5629 7.64635C13.2438 6.96545 14.0924 6.625 15.1088 6.625H32.5207L42.4582 16.5625V42.8077C42.4582 43.8241 42.1177 44.6727 41.4368 45.3536C40.7559 46.0345 39.9073 46.375 38.8909 46.375H15.1088ZM26.6601 40.3021H28.8684V38.0937H32.1809C32.4938 38.0937 32.756 37.9879 32.9676 37.7763C33.1793 37.5647 33.2851 37.3024 33.2851 36.9896V30.3646C33.2851 30.0517 33.1793 29.7895 32.9676 29.5779C32.756 29.3662 32.4938 29.2604 32.1809 29.2604H24.4518V24.8438H33.2851V22.6354H28.8684V20.4271H26.6601V22.6354H23.3476C23.0347 22.6354 22.7725 22.7412 22.5609 22.9529C22.3492 23.1645 22.2434 23.4267 22.2434 23.7396V30.3646C22.2434 30.6774 22.3492 30.9397 22.5609 31.1513C22.7725 31.3629 23.0347 31.4688 23.3476 31.4688H31.0768V35.8854H22.2434V38.0937H26.6601V40.3021ZM31.5906 16.5625H39.3198L31.5906 8.83333V16.5625Z",
    fill: "#00BCD4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequstQuote);
export default __webpack_public_path__ + "static/media/requst_quote.1cd8a61975d478445323ee35e18706af.svg";
export { ForwardRef as ReactComponent };